import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {useSettings} from '@wix/tpa-settings/react'
import {useDidUpdate} from '@wix/wix-events-commons-statics'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import settingsParams from '../../../settingsParams'
import {useModal} from '../../hooks/modal'
import {ScheduleItem} from '../../types'
import {DateDivider} from './divider'
import {ScheduleProps} from './interfaces'
import {DesktopItem, MobileItem} from './item'
import {classes as c} from './schedule.st.css'
import {Time} from './time'

export const Schedule = ({days}: ScheduleProps) => {
  const {isMobile} = useEnvironment()
  const {insideModal} = useModal()

  return (
    <div
      className={classNames(c.agenda, {
        [c.mobile]: isMobile,
        [c.insideModal]: insideModal,
      })}
    >
      {Object.values(days).map(day => (
        <ScheduleSection key={day.title} day={day} />
      ))}
    </div>
  )
}

const ScheduleSection = ({day}: {day: {title: string; items: ScheduleItem[]}}) => {
  const {isMobile} = useEnvironment()
  const settings = useSettings()
  const {insideModal} = useModal()
  const dateDividerTag = settings.get(settingsParams.dateDividerTag) as string

  useDidUpdate(() => {
    if (insideModal) {
      focusElement({selector: hookToAttributeSelector(day.title)})
    }
  }, [day.items.length])

  const Item = isMobile ? MobileItem : DesktopItem

  return (
    <div className={c.day}>
      {insideModal ? (
        <Text className={c.dayTitle} tagName="h3">
          <Time dateTime={day.title}>{day.title}</Time>
        </Text>
      ) : (
        <Text className={c.dayTitle} tagName={dateDividerTag}>
          <Time dateTime={day.title}>{day.title}</Time>
        </Text>
      )}
      <DateDivider />
      <ul aria-label={day.title} data-hook={insideModal ? day.title : null}>
        {day.items.map((item, index) => (
          <Item item={item} showDivider={index !== day.items.length - 1} key={item.id} />
        ))}
      </ul>
    </div>
  )
}
